import { useEffect, useRef } from 'react'
import Uploader from '../util/uploader'

const useUpload = (callback: InputCallback) => {
  const uploader = useRef<HTMLInputElement>()

  useEffect(() => {
    const inputDom = new Uploader(callback).getInputDom()

    uploader.current = inputDom

    return () => {
      document.body.removeChild(inputDom)
    }
  }, [callback])

  return uploader
}

export default useUpload
